import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import ResultTitle from 'components/Layout/Header/HeaderBottom/Search/Autocomplete/Result/ResultTitle';
import { AUTOCOMPLETE_CATEGORY_LIMIT } from 'config/constants';
import useTranslation from 'next-translate/useTranslation';
import React, { useCallback } from 'react';
import { SimpleCategoryType } from 'types/category';
import { onClickSuggestResultGtmEventHandler } from 'utils/Gtm/EventHandlers';

type ProductResultProps = {
    categories: SimpleCategoryType[];
    autocompleteSearchQueryValue: string;
};

const CategoryResults: FC<ProductResultProps> = ({ categories, autocompleteSearchQueryValue }) => {
    const testIdentifier = 'layout-header-search-autocomplete-input-categories';
    const { t } = useTranslation();

    const onCategoryClickHandler = useCallback(
        (category: SimpleCategoryType) => () => {
            onClickSuggestResultGtmEventHandler(autocompleteSearchQueryValue, 'category', category.name);
        },
        [autocompleteSearchQueryValue],
    );

    return (
        <>
            <ResultTitle title={t('Categories')} />
            <ul className="list-none space-y-5 p-0" data-testid={testIdentifier}>
                {categories.map(
                    (category, index) =>
                        index < AUTOCOMPLETE_CATEGORY_LIMIT && (
                            <li key={category.slug} data-testid={testIdentifier + '-' + index}>
                                <ExtendedNextLink
                                    className="flex w-full items-center text-[15px] font-bold leading-relaxed tracking-wide text-primary no-underline vl:text-body vl:leading-normal"
                                    href={category.link ?? category.slug}
                                    type="category"
                                    onClick={onCategoryClickHandler(category)}
                                >
                                    {category.name}
                                </ExtendedNextLink>
                            </li>
                        ),
                )}
            </ul>
        </>
    );
};

export default CategoryResults;
